import { CalendarDate } from "@internationalized/date";
import type { Dayjs } from "dayjs";

export function getCalendarDateFromDayjs(date: Dayjs) {
  return new CalendarDate(date.year(), date.month() + 1, date.date());
}
